export type IconType = keyof typeof iconsSrcMap

export const iconsSrcMap = {
  call: { name: "Call.svg" },
  chat: { name: "Chat.svg" },
  mail: { name: "Mail.svg" }
}
